import React from "react"
import { useStaticQuery, graphql, Script } from "gatsby"
import Cta from "./cta"
import { kebabCase } from "lodash"
export default function Instagram() {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        footer {
          instagram {
            heading
            description
            cta {
              target
              title
              url
            }
          }
        }
      }
    }
  `)
  const { heading, description, cta } = data?.wpOption?.footer?.instagram



  return (
    <aside
      className={`py-9 md:py-16 bg-white`}
    >
      <div className="container">
        {heading ? <h2 id={kebabCase(heading)} className="text-center mb-2 max-w-4xl mx-auto ">{heading}</h2> : null}
        {description ? <div className="text-center mb-6 max-w-5xl mx-auto">{description}</div> : null}
        {/* <!-- LightWidget WIDGET --> */}
        <div className="mx-auto max-w-3xl">
          <Script src="https://cdn.lightwidget.com/widgets/lightwidget.js"></Script>
          <iframe title="Jamul Casino Resort Instagram feed" src="https://cdn.lightwidget.com/widgets/b6ce0f1a84525d73a7bd1527563b40a4.html" allowTransparency="true" className="lightwidget-widget" style={{ width: "100%", border: "0", overflow: "hidden" }}></iframe>
        </div>
        {cta && (
          <div className={`flex justify-center items-center pt-6 md:pt-8`}>
            <Cta props={cta} arrow={true} />
          </div>
        )}
      </div>
    </aside>
  )
}
